//Import all frontend scripts here

// header
import { headerInit } from "./components/header";

// footer
import { footerInit } from "./components/footer";

// details block helper
import { detailsInit } from "./components/details-helper";

// Initialize components
headerInit();
footerInit();
detailsInit();
